import React, { FC } from 'react'

/**
 * @deprecated display: none can't be read by screen readers.
 * Better to add aria-* attributes for elements
 * Possible options can be found here: https://www.w3.org/WAI/tutorials/forms/labels
 */
export const AccessibilityLabel: FC<{ text: string }> = ({
  text,
  children
}) => {
  return (
    <label>
      <span style={{ display: 'none' }}>{text}</span>
      {children}
    </label>
  )
}
